import { listTypes } from '../enums';

const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit', 'view'] : ['edit', 'view', 'delete'];

export const uiConfig = {
    name: 'List Items',
    withActions: actions,
    actionConditions: {
        edit: (data) => data.listType === listTypes.AD_HOC,
        view: (data) => data.listType !== listTypes.AD_HOC,
        delete: (data) => data.listType === listTypes.AD_HOC
    },
    primaryKey: 'uuid',
    onFormMount: (data, hookFxns) => {},
    preChangeBind: (value, onChange, hookFxns) => {},
    properties: {
        itemId: {
            name: 'ID',
            input: (v) => {
                return typeof v.itemId !== 'undefined' ? 'valueDisplay' : null;
            },
            rowDisplay: false,
            sortable: false
        },
        value: {
            name: 'Value',
            input: (v) => {
                return v.itemType === listTypes.AD_HOC ? 'text' : 'valueDisplay';
            },
            sortable: true,
            rowDisplay: true,
            nullable: false,
            editable: true,
            accessorOverride: (v) => {
                if (v.itemType === listTypes.CODE_SYSTEM) {
                    return v?.cdsCodeDTO?.code ?? '';
                } else if (v.itemType === listTypes.VALUE_SET) {
                    return v?.valueSetCdsCodeRelDTO?.cdsCodeDTO?.code ?? '';
                } else if (v.itemType === listTypes.AD_HOC_CONCEPT) {
                    return v?.openCdsConceptDTO?.code ?? '';
                } else {
                    if (typeof v === 'string') {
                        return v;
                    } else {
                        return v?.adHocId ?? '';
                    }
                }
            },
            postChangeBind: (v, onChange, hookFxns) => {}
        },
        label: {
            name: 'Label',
            rowDisplay: true,
            sortable: true,
            nullable: false,
            editable: true,
            input: (v) => {
                return v.itemType === listTypes.AD_HOC ? 'text' : 'valueDisplay';
            },
            accessorOverride: (v) => {
                if (v.itemType === listTypes.VALUE_SET) {
                    return `${v?.valueSetCdsCodeRelDTO?.cdsCodeDTO?.displayName ?? ''} (${v.valueSetCdsCodeRelDTO
                        ?.cdsCodeDTO?.code ?? ''})`;
                } else if (v.itemType === listTypes.CODE_SYSTEM) {
                    return `${v?.cdsCodeDTO?.displayName ?? ''} (${v?.cdsCodeDTO?.code ?? ''})`;
                } else if (v.itemType === listTypes.AD_HOC_CONCEPT) {
                    return `${v?.openCdsConceptDTO?.displayName ?? ''} (${v?.openCdsConceptDTO?.code ?? ''})`;
                } else {
                    if (typeof v === 'string') {
                        return v;
                    } else {
                        return v?.adHocLabel ?? '';
                    }
                }
            }
        }
    },
    newDoc: {
        itemType: listTypes.AD_HOC,
        dtoState: 'NEW',
        adHocId: '',
        adHocLabel: ''
    },
    sortBy: {
        columnId: 'Value',
        desc: false
    }
};

export default uiConfig;
